/**
 * Automy.Core.Enums.Reporting.Identity.SystemReportType
 * Internal Excel jobs. Outside ReportProvider.Native. JSON integer.
 */
export default Object.freeze({
  DailySupportErrorsSummary: 1, // daily-support-errors-summary
});
